import React from 'react';
import { Banner, Navigation } from '../layouts';

export default function Header(props) {
  const { auth, logout } = props;
  return (
    <>
      <Banner />
      <Navigation auth={auth} logout={logout}/>
    </>
  );
}
